var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("h1", { staticClass: "section-title" }, [
      _vm._v(_vm._s(_vm.$t("identityProvider:error:title")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "alert alert-danger fade show", attrs: { role: "alert" } },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$t("identityProvider:error:instructions", null, [
                _vm.$t("identityProvider:tenant:supportName"),
                _vm.$t("identityProvider:tenant:customerServicePhoneNumber")
              ])
            )
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-517182b6", { render: render, staticRenderFns: staticRenderFns })
  }
}